import React, {useContext} from "react";
import {DataContext} from "../Context/DataContext";

export default function CountryButton({position, flag, name}) {
	const {activeCountries, setActiveCountries} = useContext(DataContext);

	// Show or hide the country window
	const showOrHideCountry = () => {
		let newActiveCountries = activeCountries;
		newActiveCountries = [false, false, false];
		newActiveCountries[position - 1] = !activeCountries[position - 1];
		setActiveCountries(newActiveCountries);
	};

	return (
		<button
			className='country-button'
			onClick={showOrHideCountry}
			style={{
				backgroundColor: activeCountries[position - 1] ? "var(--blue)" : "var(--gray-0)",
			}}>
			<p style={{color: activeCountries[position - 1] ? "var(--white)" : "var(--gray-3)"}}>{position}</p>
			<img src={flag} alt={`Bandera de ${name}`}></img>
			<p style={{color: activeCountries[position - 1] ? "var(--white)" : "var(--blue)"}}>{name}</p>
		</button>
	);
}
